import {
	TOGGLE_BARCODE_SCANNER_SECONDARY,
	TOGGLE_BARCODE_SCANNER,
	TOGGLE_BARCODE_RESULTS
} from './types';

export const toggleBarcodeScanner = (payload) => ({
	type: TOGGLE_BARCODE_SCANNER,
	payload
})

export const toggleBarcodeScannerSecondary = payload => {
	return async (dispatch, getState) => {
		dispatch({
			type: TOGGLE_BARCODE_SCANNER_SECONDARY,
			payload
		});
    }
}

export const toogleBarcodeResults = (payload) => ({
	type: TOGGLE_BARCODE_RESULTS,
	payload
})

export const setScannerResult = (payload) => ({
	type: types.SET_SCANNER_RESULT,
	payload
})

export const setFailedStatus = (payload) => ({
	type: types.SET_FAILED_STATUS,
	payload
})


export const setBarcodeData = (payload) => {
	// return async (dispatch, getState) => {
	// 	await registerReducer(getStore(),['barcodeScanner']); //SAFE TO CALL getSTore on client
	// 	dispatch({
	// 		type: types.SET_BARCODE_DATA,
	// 		payload
	// 	});
    // }	
}


export const resetBarcodeData = () => ({
	type: types.RESET_BARCODE_DATA
})
